import { PiCarProfileBold } from "react-icons/pi";
import Layout from "./Layout";

const Result = () => {
    return (
        <Layout>

            <div>
                <div className="justify-center  mb-8 text-center mt-4 md:mt-8 flex place-items-center">
                    <div className="">
                        <img src="/logo.png" alt=""
                            className="w-20" />
                    </div>
                    <div className="">
                        <h1>Devine Royal Results</h1>
                        <h2>Check Your Results</h2>
                    </div>
                </div>

                <div>
                    <div className="space-y-6 max-[670px]:grid max-[670px]:grid-cols-2 maxmax-[670px]:grid max-[670px]:gap-2 px-6 md:flex md:place-items-center md:justify-evenly">

                        <div>
                            <label>Examination Number</label>
                            <input type="text"
                                className="bg-gray-50 md:mt-3 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500  md:w-full p-2.5 " placeholder="123567" required />
                        </div>

                        <div className="">
                            <label>PIN</label>
                            <input type="text"
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500  md:w-full p-2.5 " placeholder="123567" required />
                        </div>

                        <div>
                            <label for="countries" className="  block mb-2 text-sm font-medium text-gray-900 dark:text-white">Examination Year</label>
                            <select>
                                <option selected>2023</option>
                                <option>2022</option>
                                <option>2020</option>
                                <option>2019</option>
                                <option>2018</option>
                            </select>
                        </div>


                        <button className="bg-[#f7951e] px-6 py-3  mt-8">Submit</button>
                    </div>

                    <div className=" md:border font-serif md:border-gray-300 text-center rounded-xl mx-8 mt-6">
                        <h1 className="text-xl mt-4">Your Result would show here</h1>


                        <div className="flex justify-center">
                            <table className="border-2  text-left">

                                <tr className="border-2">
                                    <th>Academic Session</th>
                                    <td className="border-2">year</td>
                                </tr>

                                <tr className="border-2">
                                    <th>Term</th>
                                    <td className="border-2">Term</td>
                                </tr>

                                <tr className="border-2">
                                    <th>Sex</th>
                                    <td className="border-2">Female</td>
                                </tr>
                                <tr className="border-2">
                                    <th>Date Of Closure</th>
                                    <td className="border-2">Febuary 15 2023</td>
                                </tr>
                            </table>

                            <table className="border-2">

                                <tr className="border-2">
                                    <th className="border-2">Academic No</th>
                                    <td className="border-2">SDR45</td>
                                </tr>

                                <tr className="border-2">
                                    <th className="border-2">Class</th>
                                    <td className="border-2">SS2A</td>
                                </tr>

                                <tr className="border-2">
                                    <th className="border-2">Club</th>
                                    <td className="border-2">Female</td>
                                </tr>
                                <tr className="border-2">
                                    <th className="border-2">Date Of reopening</th>
                                    <td className="border-2">Febuary 15 2024</td>
                                </tr>
                            </table>
                            <PiCarProfileBold className="text-4xl" />
                        </div>


                        <div className="flex mt-8 justify-evenly overflow-x-scroll">

                            <div className="flex-col flex text-left  ">

                                <div className="flex space-y-4 flex-col">
                                    <table>
                                        <tr className="border-2">
                                            <th className="border-2  px-4 md:px-4">COGNITIVE DOMAIN SUBJECTS</th>
                                            <th className="border-2  px-4 md:px-4"> <h1>TEST</h1> <h1>30%</h1></th>
                                            <th className="border-2  px-4 md:px-4"><h1>EXAM</h1> <h1>70%</h1></th>
                                            <th className="border-2  px-4 md:px-4"><h1>TOTAL</h1> <h1>100%</h1></th>
                                            <th className="border-2 px-4 md:px-4">GRADE</th>
                                        </tr>
                                        <tr className="border-2  ">
                                            <td className="border-2 ">ENGLISH LANGUAGE</td>
                                            <td className="border-2  px-4 md:px-4">20</td>
                                            <td className="border-2">55</td>
                                            <td className="border-2">75</td>
                                            <td className="border-2">B7</td>
                                        </tr>
                                        <tr className="border-2">
                                            <td className="border-2"> MATHEMATICS</td>
                                            <td className="border-2">16</td>
                                            <td className="border-2">24</td>
                                            <td className="border-2">24</td>
                                            <td className="border-2">B7</td>
                                        </tr>
                                        <tr className="border-2">
                                            <td className="border-2">CHEMISTRY</td>
                                            <td className="border-2">23</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">B7</td>
                                        </tr>
                                        <tr className="border-2">
                                            <td className="border-2">PHYSICS</td>
                                            <td className="border-2">23</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">B7</td>
                                        </tr>  <tr className="border-2">
                                            <td className="border-2">CIVIC EDUCATION</td>
                                            <td className="border-2">23</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">B7</td>
                                        </tr>  <tr className="border-2">
                                            <td className="border-2">PHILOSPHY</td>
                                            <td className="border-2">23</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">B7</td>
                                        </tr>  <tr className="border-2">
                                            <td className="border-2">BIOLOGY</td>
                                            <td className="border-2">23</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">B7</td>
                                        </tr>  <tr className="border-2">
                                            <td className="border-2">AGRIC SCIENCE</td>
                                            <td className="border-2">23</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">B7</td>
                                        </tr>  <tr className="border-2">
                                            <td className="border-2">DATA PROCCESSING</td>
                                            <td className="border-2">23</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">B7</td>
                                        </tr>  <tr className="border-2">
                                            <td className="border-2">IGBO LANGUAGE</td>
                                            <td className="border-2">23</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">48</td>
                                            <td className="border-2">B7</td>
                                        </tr>
                                    </table>

                                    <table className="border-2">
                                        <th><h2>SUMMARY OF COGNITIVE DOMAIN REPORT</h2></th>
                                        <tr className="border-2">
                                            <th>TOTAL SCORE</th>
                                            <td className="border-2">670</td>
                                        </tr>

                                        <tr className="border-2">
                                            <th>AVERAGE SCORE</th>
                                            <td className="border-2">67%</td>
                                        </tr>

                                        <tr className="border-2">
                                            <th>CLASS AVERAGE</th>
                                            <td className="border-2">Female</td>
                                        </tr>
                                        <tr className="border-2">
                                            <th>NO. IN CLASS</th>
                                            <td className="border-2">53</td>
                                        </tr>
                                        <tr className="border-2">
                                            <th>POSITION </th>
                                            <td className="border-2">18TH</td>
                                        </tr>
                                        <tr className="border-2">
                                            <th>RESULT</th>
                                            <td className="border-2">PASS</td>
                                        </tr>
                                    </table>
                                </div>

                            </div>

                            <div className="space-y-4">
                                <table className="border-2 text-left">
                                    <tr className="text-sm">
                                        <td className="text-sm">
                                            <h2>AFFECTIVE DOMAIN</h2>
                                            <h2>BEHAVIOURS</h2>
                                        </td>
                                        <td className="border-2 px-4 md:px-4">GRADING</td>
                                        <td className="border-2  px-4 md:px-4">
                                            <h2> PSYCHOMOTOR DOMAIN</h2>
                                            <h2>ACTIVIES</h2>
                                        </td>
                                        <td className="border-2  px-4 md:px-4">GRADING</td>
                                    </tr>

                                    <tr className="border-2">
                                        <td className="border-2">
                                            Attandance
                                        </td>
                                        <td className="border-2">B</td>
                                        <td className="border-2">Handwriting Skills</td>
                                        <td className="border-2">B</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2">
                                            Attandance
                                        </td>
                                        <td className="border-2">B</td>
                                        <td className="border-2">Handwriting Skills</td>
                                        <td className="border-2">B</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2">
                                            Attandance
                                        </td>
                                        <td className="border-2">B</td>
                                        <td className="border-2">Handwriting Skills</td>
                                        <td className="border-2">B</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2">
                                            Attandance
                                        </td>
                                        <td className="border-2">B</td>
                                        <td className="border-2">Handwriting Skills</td>
                                        <td className="border-2">B</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2">
                                            Attandance
                                        </td>
                                        <td className="border-2">B</td>
                                        <td className="border-2">Handwriting Skills</td>
                                        <td className="border-2">B</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2">
                                            Attandance
                                        </td>
                                        <td className="border-2">B</td>
                                        <td className="border-2">Handwriting Skills</td>
                                        <td className="border-2">B</td>
                                    </tr>  <tr className="border-2">
                                        <td className="border-2">
                                            Attandance
                                        </td>
                                        <td className="border-2">B</td>
                                        <td className="border-2">Handwriting Skills</td>
                                        <td className="border-2">B</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2">
                                            Attandance
                                        </td>
                                        <td className="border-2">B</td>
                                        <td className="border-2">Handwriting Skills</td>
                                        <td className="border-2">B</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2">
                                            Attandance
                                        </td>
                                        <td className="border-2">B</td>
                                        <td className="border-2">Handwriting Skills</td>
                                        <td className="border-2">B</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2">
                                            Attandance
                                        </td>
                                        <td className="border-2">B</td>
                                        <td className="border-2">Handwriting Skills</td>
                                        <td className="border-2">B</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2">
                                            Attandance
                                        </td>
                                        <td className="border-2">B</td>
                                        <td className="border-2">Handwriting Skills</td>
                                        <td className="border-2">B</td>
                                    </tr>
                                </table>


                                <table className="border-2 ">
                                    <tr className="border-2">
                                        <th>SCORES</th>
                                        <th>GRADES</th>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2 px-4 md:px-24"> 80-100%</td>
                                        <td className="border-2 px-4 md:px-24">AI Excellent</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2"> 80-100%</td>
                                        <td className="border-2">AI Excellent</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2"> 80-100%</td>
                                        <td className="border-2">AI Excellent</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2"> 80-100%</td>
                                        <td className="border-2">AI Excellent</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2"> 80-100%</td>
                                        <td className="border-2">AI Excellent</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2"> 80-100%</td>
                                        <td className="border-2">AI Excellent</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2"> 80-100%</td>
                                        <td className="border-2">AI Excellent</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2"> 80-100%</td>
                                        <td className="border-2">AI Excellent</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2"> 80-100%</td>
                                        <td className="border-2">AI Excellent</td>
                                    </tr>
                                    <tr className="border-2">
                                        <td className="border-2"> 80-100%</td>
                                        <td className="border-2">AI Excellent</td>
                                    </tr>
                                </table>
                            </div>



                        </div>

                        <div className="flex mb-8 justify-around mt-4 place-items-center md:mt-8">
                            <div className="font-serif text-[14px] space-y-4 text-gray-800">
                                <p className="flex  space-x-2">
                                    <h2>TEACHER'S COMMENT:</h2>
                                    <h2 className="underline underline-offset-2">This is a fair result, but you can do better</h2>
                                </p>
                                <p className="flex space-x-2">
                                    <h2>DIRECTOR'S COMMENT:</h2>
                                    <h2 className="underline underline-offset-2">This is a fair result, but you can do better</h2>
                                </p>
                            </div>
                            <div className="border-2 border-gray-200 px-3 py-4">
                            <h1 className="text-sm">Signed</h1>
                            <hr className="mt-2"/>
                                <h2>
                                    <h2> Sir J.O Mban</h2>
                                    <h3>Director</h3>
                                </h2>
                            </div>
                        </div>

                    </div>


                    <div>

                    </div>
                </div>



            </div>

        </Layout>
    );
}

export default Result;